var A = /* @__PURE__ */ ((E) => (E[E.INACTIVE = 1] = "INACTIVE", E[E.ACTIVE = 2] = "ACTIVE", E[E.EXPIRED = 3] = "EXPIRED", E[E.DELETED = 4] = "DELETED", E))(A || {}), I = /* @__PURE__ */ ((E) => (E[E.ON_ARRIVAL = 1] = "ON_ARRIVAL", E[E.ON_DEPARTURE = 2] = "ON_DEPARTURE", E[E.ON_BIRTHDAY = 3] = "ON_BIRTHDAY", E[E.ON_TRANSACTION = 9] = "ON_TRANSACTION", E))(I || {});
export {
  A as LoyaltyProgrammeStatus,
  I as LoyaltyProgrammeTriggerCondition
};
//# sourceMappingURL=loyaltyProgrammeEnums.js.map
